import React from 'react'
import TranslationContext from './TranslationContext'
import type { TranslationContextValue } from './TranslationContext'

export interface WithTranslation {
  translation: TranslationContextValue
}

export function withTranslation<P extends WithTranslation>(
  Component: React.ComponentType<P>
): React.ComponentType<Omit<P, keyof WithTranslation>> {
  const displayName = Component.displayName || Component.name || 'Component'

  function WithTranslationWrapper(props: Omit<P, keyof WithTranslation>) {
    return (
      <TranslationContext.Consumer>
        {(translation) => <Component {...(props as P)} translation={translation} />}
      </TranslationContext.Consumer>
    )
  }

  WithTranslationWrapper.displayName = `withTranslation(${displayName})`
  return WithTranslationWrapper
}
